import { isSponsoredProduct } from '@shared/types/types';
import { type TileListItem, isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

type EventName = { ios: string; android: string };

const eventNames = {
    Produktliste: {
        android: 'tap3xe',
        ios: 'duht9i',
    },
    Suchergebnisseite: {
        android: '9ldrbv',
        ios: 'kxrhs8',
    },
} satisfies Record<string, EventName>;

type PageTypes = keyof typeof eventNames;

const isPageType = (pageType: string | undefined): pageType is PageTypes => !!pageType && pageType in eventNames;

const MAX_ITEMS_TO_TRACK = 4;

let trackAdjustPromise: Promise<typeof import('@otto-ec/apps-api/thirdpartytracking')> | null = null;

const getTrackAdjust = () => {
    trackAdjustPromise ??= import('@otto-ec/apps-api/thirdpartytracking');
    return trackAdjustPromise;
};

export async function trackAdjustForTileList(
    tileListItems: TileListItem[],
    onex?: OnEx,
    sitePath = window.location.href,
) {
    if (onex?.isToggleActive('EMERGENCY_DISABLE_APPS_TRACKING')) return;

    const { trackAdjust } = await getTrackAdjust();

    const avContent = document.getElementById('avContent');

    if (!avContent) {
        const eventName = eventNames['Produktliste']; /*      */
        trackAdjust({
            eventName,
            partnerParameters: {
                articleids: '[]',
                contentType: 'product',
            },
        });

        return;
    }

    const pageType = avContent.dataset.pt;

    if (!isPageType(pageType)) return;

    const eventName = eventNames[pageType];

    const articleNumbersToTrack = tileListItems
        .filter(isProductItem)
        .filter(({ product }) => !isSponsoredProduct(product))
        .map(({ product }) => product.articleNumber)
        .filter((articleNumber): articleNumber is string => Boolean(articleNumber))
        .slice(0, MAX_ITEMS_TO_TRACK);

    trackAdjust({
        eventName,
        partnerParameters: {
            articleids: JSON.stringify(articleNumbersToTrack),
            contentType: 'product',
            sitePath,
        },
    });
}
